<!--
 * @Description: 绑定表单组件
--> 

<template>
  <div class="bind-form">
    <van-form @submit="onSubmit">
      <van-field
        required
        center
        clearable
        label="水表类别"
        readonly>
        <template #input>
          <van-radio-group v-model="typeid" direction="horizontal">
            <van-radio name="0" >普通水表</van-radio>
            <van-radio name="1" >代码表</van-radio>
          </van-radio-group>
        </template>
    </van-field>
    <van-field
      required
      :rules="[{ required: true, message: '请输入查询用户号' }]"
      v-model="userno"
      label="用户号"
      placeholder="请输入用户号"/>
    <van-field
      required
      v-model="username"
      label="用户名"
      placeholder="请输入查询用户名"
      :rules="[{ required: true, message: '请输入查询用户名' }]"/>
    <div style="margin:17px 16px;margin-bottom:36.5px;">
      <!-- <van-button
        type="info"
        color="#1677FF"
        size="large"
        native-type="submit"
        class="submit-btn"
        >
        立即绑定
      </van-button> -->
      <van-button type="primary" block color="linear-gradient(178deg, #4D99F6 0%, #3782E9 100%)" >立即绑定</van-button>
    </div>
    </van-form>
    <div class="remark">
      绑定说明：
      <br><br>1、用户号可通过“户号查询”自助获取，也可从水费通知短信、水费发票上获取，另外还可以拨打服务热线85117474查询。
      <br><br>2、户名为用户在供水公司登记的用户名称。
      <br><br>3、任何组织或个人未经户主许可，不得绑定他人用户号，未经被绑定用户号户主许可，而绑定造成损失和法律责任由绑定者全部承担。
      <br><br>4、同一注册号可绑定多个用户号。
    </div>
  </div>
</template>

<script>
// import smsBtn from '@/components/smsBtn.vue'
export default {
  name: 'BindForm',
  components: {
    // smsBtn
  },
  data() {
    return {
      userno: '',
      username: '',
      typeid:"0"
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      let result = ''
      if(value.length>3){
        result = value.substring(0,3)+"****"+value.substring(value.length-4)
      }else{
        result = "*"+value.substring(1,value.length)
      }
      return result
    }
  },
  methods: {
    onSubmit() {
      let params = {
        "typeid":this.typeid,
        "userno": this.userno,
        "username": this.username,
      }
      this.$http.post(this.$api.userBind, params).then(res => {
        if (res.code==='000') {
          this.$toast('绑定成功')
          this.$router.go(-1)
        } else {
          this.$toast(res.msg)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.bind-form{
  .search-btn{
    width:70px;
    height:30px;
    background:rgba(37,138,55,1);
    border-radius:3px;
    border-color: rgba(37,138,55,1);
  }
  .get-code{
    width:80px;
    height:30px;
    background:rgba(255,255,255,1);
    border-radius:3px;
    border:1px solid rgba(37,138,55,1);
    font-size:12px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(37,138,55,1);
  }
  .submit-btn{
    height:44px;
    background:rgba(37,138,55,1);
    border-radius:5px;
  }
  .remark{
    padding: 0 20px;
    font-size:10px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(153,153,153,1);
    margin-top: -10px;
    margin-bottom: 40px;
  }
}
</style>